import { ArrowRight, ArrowLeft, Loader2, SkipForward } from 'lucide-react';

export function QuestionActions({ 
  onBack, 
  onSkip, 
  onNext, 
  loading, 
  isValidating, 
  isRequired, 
  validationWarning,
  language,
  t 
}) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 fade-in-up" style={{ animationDelay: '0.3s' }}>
      <button
        onClick={onBack}
        data-testid="back-question-btn"
        className="cyber-btn-outline px-6 py-3 flex items-center justify-center gap-2 rounded-md"
      >
        <ArrowLeft className="w-4 h-4" />
        <span>{t('back')}</span>
      </button>
      
      {!isRequired && (
        <button
          onClick={onSkip}
          data-testid="skip-question-btn"
          disabled={loading}
          className="cyber-btn-outline px-6 py-3 flex items-center justify-center gap-2 rounded-md flex-1"
        >
          <span>{t('skip')}</span>
          <SkipForward className="w-4 h-4" />
        </button>
      )}
      
      <button
        onClick={onNext}
        disabled={loading || isValidating}
        data-testid="next-question-btn"
        className="cyber-btn px-6 py-3 flex items-center justify-center gap-2 flex-1"
      >
        {isValidating ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            <span>{language === 'it' ? 'Verifica...' : 'Checking...'}</span>
          </>
        ) : validationWarning ? (
          <>
            <span>{language === 'it' ? 'Procedi comunque' : 'Proceed anyway'}</span>
            <ArrowRight className="w-4 h-4" />
          </>
        ) : (
          <>
            <span>{t('next')}</span>
            <ArrowRight className="w-4 h-4" />
          </>
        )}
      </button>
    </div>
  );
}

export function AnsweredCount({ count, language }) {
  return (
    <div className="mt-6 text-center font-mono text-xs text-gray-500">
      {count} {language === 'it' ? 'risposte salvate' : 'answers saved'}
    </div>
  );
}
